import React, { useState } from "react";

const Pagination = ({ totalItems, itemsPerPage, currentPage,goToPage }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  // const [currentPage, setCurrentPage] = useState(1);
  const visiblePages = 5; // show 5 pages at a time
console.log(currentPage, "currentPagecurrentPage")
  // const goToPage = (page) => {
  //   if (page < 1 || page > totalPages) return;
  //   setCurrentPage(page);
  //   onPageChange(page);
  // };

  // Determine start and end page numbers to show
  const getPageNumbers = () => {
    let start = Math.max(1, currentPage - Math.floor(visiblePages / 2));
    let end = start + visiblePages - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - visiblePages + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pages = getPageNumbers();

  return (
    <nav aria-label="Page navigation example">
      <ul className="pagination justify-content-end">
        {/* Previous Button */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => goToPage(currentPage - 1)}
            aria-disabled={currentPage === 1}
          >
            <i className="fa-solid fa-chevron-left"></i>
          </button>
        </li>

        {/* Show first page + ellipsis if needed */}
        {pages[0] > 1 && (
          <>
            <li className="page-item">
              <button className="page-link" onClick={() => goToPage(1)}>
                1
              </button>
            </li>
            {pages[0] > 2 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
          </>
        )}

        {/* Page Numbers */}
        {pages.map((page) => (
          <li
            key={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button className="page-link" onClick={() => goToPage(page)}>
              {page}
            </button>
          </li>
        ))}

        {/* Show ellipsis + last page if needed */}
        {pages[pages.length - 1] < totalPages && (
          <>
            {pages[pages.length - 1] < totalPages - 1 && (
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            )}
            <li className="page-item">
              <button
                className="page-link"
                onClick={() => goToPage(totalPages)}
              >
                {totalPages}
              </button>
            </li>
          </>
        )}

        {/* Next Button */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => goToPage(currentPage + 1)}
            aria-disabled={currentPage === totalPages}
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
